// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

export enum FeaturesTypeViewModel {
	None = 0,
	Image = 1,
	UmbracoNameTranslation = 2,
	HtmlValue = 4,
	UmbracoValueTranslation = 8,
	JoinNewLine = 16,
	List = 32,
	HtmlName = 64,
	BoldName = 128,
	Indent = 256,
	NoCase = 512,
}
